import { POST } from "./utils";
import { projectSelector } from "@rflocal/shared";

export interface ReencodeVideoRequest {
    fileId: string;
    outputFormat?: "mp4" | "webm";
}

export interface ReencodeVideoResponse {
    fileId: string;
    storageUrl: string;
    codecInfo: { codecName: string; formatName: string; wasReencoded: boolean };
}

/**
 * Re-encode a video file to a compatible browser format
 * If the video is already compatible, returns the original file info
 */
export const reencodeVideo = async (
    request: ReencodeVideoRequest
): Promise<ReencodeVideoResponse> => {
    console.log("📹 [VIDEO API] Calling re-encode endpoint:", { request });

    try {
        const response = await POST("/api/video/reencode", request);
        console.log("📹 [VIDEO API] ✅ Re-encode response:", response);
        return response;
    } catch (error) {
        console.error("📹 [VIDEO API] ❌ Re-encode failed:", error);
        throw error;
    }
};
